import {
  getRolesWithMultipleSpecsTreatingDpsAsOne,
  getSpecializationsByClass,
} from 'app/frontend/base/services/characterValues'

type ResolveSelectionOverrideDisplayInput = {
  classId?: number
  role: string
  specId: number | null
  mainRole: string
  mainSpecId: number | null
}

export const resolveSelectionOverrideDisplay = ({
  classId,
  role,
  specId,
  mainRole,
  mainSpecId,
}: ResolveSelectionOverrideDisplayInput) => {
  const hasRoleOverride = role !== mainRole
  const hasSpecOverride = specId !== mainSpecId
  if (!classId) {
    return {
      hasRoleOverride,
      hasSpecOverride,
      showRoleIcon: hasRoleOverride,
      showSpecIcon: false,
      specIcon: undefined as string | undefined,
    }
  }

  const classSpecializations = getSpecializationsByClass(classId)
  const encounterSpec = specId ? classSpecializations[specId] : undefined
  const rolesWithMultipleSpecs =
    getRolesWithMultipleSpecsTreatingDpsAsOne(classId)
  const shouldShowSpecForRoleOverride =
    hasRoleOverride && !!encounterSpec && rolesWithMultipleSpecs.includes(role)
  const showSpecIcon =
    shouldShowSpecForRoleOverride ||
    (!hasRoleOverride && hasSpecOverride && !!encounterSpec)

  return {
    hasRoleOverride,
    hasSpecOverride,
    showRoleIcon: hasRoleOverride && !shouldShowSpecForRoleOverride,
    showSpecIcon,
    specIcon: encounterSpec?.icon,
  }
}
